module.exports = __webpack_public_path__ + "static/Verizon_New_Brand_Module_Excerpt-49d03d6a1970bff404fc949e07374cb0.jpg";